import React, { useState } from "react";

const SearchForm = ({ onSearch }) => {
    const [dataSearch, setDataSearch] = useState({
        sCode: "",
        sName: "",
        sAddress: "",
        sPhone: "",
        sStatus: "",
    });

    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSearch(dataSearch);
        }
    };

    const handleSearchClick = () => {
        onSearch(dataSearch);
    };

    return (<>
        <div className="search-new">
            <div className="input-sm-new input-new-18">
                <label htmlFor="sCode" className="font-color-default font-bold">Tìm kiếm</label>
                <input
                    id="sCode"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Mã cửa hàng"
                    onChange={onChangeData("sCode")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.sCode}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="sName" className="font-color-default font-bold">Tên cửa hàng</label>
                <input
                    id="sName"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Tên cửa hàng"
                    onChange={onChangeData("sName")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.sName}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="sPhone" className="font-color-default font-bold">Điện thoại</label>
                <input
                    id="sPhone"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Điện thoại"
                    onChange={onChangeData("sPhone")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.sPhone}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="sAddress" className="font-color-default font-bold">Địa chỉ</label>
                <input
                    id="sAddress"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Địa chỉ"
                    onChange={onChangeData("sAddress")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.sAddress}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="sStatus" className="font-color-default font-bold">Trạng thái</label>
                <select id="sStatus" name="sStatus"
                    value={dataSearch.sStatus}
                    onChange={onChangeData("sStatus")}
                    className="form-control input-sm">
                    <option value="">Tất cả</option>
                    <option value="1">Đang hoạt động</option>
                    <option value="0">Tạm ngưng</option>
                </select>
            </div>
            <div className="input-sm-new input-new-18 search-main-new">
                <label htmlFor="submit" className="font-color-default font-bold" >&nbsp;</label>
                <button
                    id="submit"
                    name="submit"
                    type="submit"
                    className="btn btn-info-new"
                    onClick={handleSearchClick}
                >
                    <i className="la la-search"></i>
                    <span> &nbsp; Tìm kiếm</span>
                </button>
            </div>
        </div>
    </>
    )
};


export default SearchForm;